export default {
  options(h, conf, key) {
    const list = []
    conf.__slot__.options.forEach(item => {
      // 多选：value 为 A/B/C/D，展示字母 + 文案
      const text = item.label ? `${item.value}. ${item.label}` : `${item.value}`
      if (conf.__config__.optionType === "button") {
        list.push(
          <el-checkbox-button label={item.value}>
            {text}
          </el-checkbox-button>
        )
      } else {
        list.push(
          <el-checkbox label={item.value} border={conf.border}>
            {text}
          </el-checkbox>
        )
      }
    })
    return list
  }
}
